/* eslint-disable */
import React from 'react';

import './styles/styles.css'
import background from '../assets/images/woman-on-phone-1.png'
import screenshots from '../assets/images/how-bins-works-4.png'
import screenshots2 from '../assets/images/facility-owners.png'
import SEO from './SEO';
import ReviewsStrip from './ReviewsStrip';

const Landing = () => (
  <>
    <SEO
      title="Bins Storage | Valet Storage in San Francisco, Berkeley & Richmond"
      description="Bins Storage offers full-service valet storage in San Francisco, Berkeley, and Richmond with pickup and delivery designed for busy renters and households."
      path="/"
    />          
      <div>
        {/* HERO SECTION */}
        <section class="home" id="home">
          <div class="h2"/>
          <div class="content">
            <h1>
              <span class="altColor">Smooth & Stress-Free</span> Storage
            </h1>
            <p class="a">
              We pick up, store, and deliver your belongings — no truck, no hassle.
            </p>
            <p>
              Quickly store items or have them delivered, without leaving your home.
            </p>
            <p>
              Learn More
            </p>
            <div class="down-arrow"></div>
          </div>
          <div class="image">
            <img src={background} alt="Woman scheduling valet storage pickup on her phone in San Francisco"/>
          </div>
        </section>

        {/* TENANT SECTION */}
        <section class="tenants" id="tenants">
        <div class ="paddingContainer"></div>
          {/* Image */}
          <div class="image">
            <img src={screenshots} alt="Bins Storage app showing how valet storage pickup and delivery works"/>
          </div>
          {/* Text */}
          <div class="content">
            <h1>
              FOR TENANTS
            </h1>
            <h2>
              Hassle-Free, <span class="purpleColor">Convenient Storage</span>
            </h2>
            <p>
              We allow customers to virtually view items in storage, then schedule deliveries. Bins provides convenience and eliminates the need to pack, lift, or drive. Customers can see everything in storage without having to dig through their unit.
            </p>
            <div class="buttonContainer">
              <a href="/Download" class="button1">
                  Reserve Now
              </a>
              <a href="/About" class="button2">
                  Learn More
              </a>
            </div>
          </div>
        </section>

        {/* WHERE WE SERVE */}
        <section style={{ backgroundColor: '#F9F6FC', padding: '3.5rem 2rem', textAlign: 'center' }}>
          <h2 style={{ fontFamily: 'Raleway, sans-serif', fontSize: '2rem', fontWeight: 700, color: '#261136', marginBottom: '0.5rem' }}>
            Where We Serve
          </h2>
          <p style={{ fontFamily: 'Raleway, sans-serif', fontSize: '1.05rem', color: '#555', maxWidth: 560, margin: '0 auto 2rem', lineHeight: 1.65 }}>
            Bins is live in the San Francisco Bay Area and Tacoma, WA – with more cities on the way.
          </p>
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/san-francisco" style={{ display: 'block', backgroundColor: '#7B1FA2', color: '#FFF', fontFamily: 'Raleway, sans-serif', fontWeight: 700, fontSize: '1rem', padding: '1.5rem 2.5rem', borderRadius: 12, textDecoration: 'none', minWidth: 220, textAlign: 'center' }}>
              <div style={{ fontSize: '1.5rem', marginBottom: '0.4rem' }}>🌉</div>
              <div>San Francisco Bay Area</div>
              <div style={{ fontSize: '0.85rem', opacity: 0.8, marginTop: '0.25rem' }}>SF, Oakland, Berkeley & more</div>
            </a>
            <a href="/tacoma" style={{ display: 'block', backgroundColor: '#261136', color: '#FFF', fontFamily: 'Raleway, sans-serif', fontWeight: 700, fontSize: '1rem', padding: '1.5rem 2.5rem', borderRadius: 12, textDecoration: 'none', minWidth: 220, textAlign: 'center' }}>
              <div style={{ fontSize: '1.5rem', marginBottom: '0.4rem' }}>🏔</div>
              <div>Tacoma, WA</div>
              <div style={{ fontSize: '0.85rem', opacity: 0.8, marginTop: '0.25rem' }}>Tacoma, Lakewood, Puyallup & more</div>
            </a>
          </div>
        </section>

        {/* CUSTOMER REVIEWS */}
        <ReviewsStrip />

        {/* FACILITIES SECTION */}
        <section class="facilities" id="facilities">
        <div class ="paddingContainer"></div>
          {/* Text */}
          <div class="content">
            <h1>
              FOR FACILITIES
            </h1>
            <h2>
              Smart Space Optimization
            </h2>
            <p>
              Bins provides storage facilities with the technology and management system to implement valet storage, increasing revenues by filling vacancies and expanding the market. All without any additional cost. 
            </p>
            <div class="buttonContainer">
              <a href="/Contact" class="button1">
                    Contact Us
              </a>
              <a href="/About" class="button2">
                    Learn More
              </a>
            </div>
          </div>
          {/* Image */}
          <div class="image">
            <img src={screenshots2} alt="Bins Storage facility management dashboard for storage operators"/>
          </div>
        </section>
        </div>
    </>
)

export default Landing;
